<template>
  <li class="x-tree-node">
    <div
      class="toolbar-section atb-flex-auto atb-text-sm"
      @click="toggle"
    >
      <p class="tree-item-icon">
        <img
          :src="currentImage"
          alt="Current Image"
        />
      </p>
      <p class="tree-item-content">
        <label>{{ model.label }}</label>
      </p>
    </div>
    <ul
      v-show="isOpen"
      v-if="isFolder"
    >
      <draggable
        :list="model.children"
        itemKey="label"
        :sort="false"
      >
        <template #item="{ element }">
          <TreeItem :model="element" />
        </template>
      </draggable>
    </ul>
  </li>
</template>

<script lang="ts" setup>
  import { computed, ref, toRefs } from 'vue';
  import folderOpenIcon from '@/assets/images/tree/folder-open.gif';
  import folderCloseIcon from '@/assets/images/tree/folder.gif';
  import leafIcon from '@/assets/images/tree/leaf.gif';
  import draggable from 'vuedraggable';

  interface TreeNode {
    label: string;
    children: Array<TreeNode> | undefined;
  }

  interface TreeItemProps {
    model: TreeNode;
  }

  const props = defineProps<TreeItemProps>();
  const { model } = toRefs(props);
  const isOpen = ref(false);
  const isFolder = computed(() => {
    return model.value.children && model.value.children.length > 0;
  });

  const toggle = () => {
    isOpen.value = !isOpen.value;
  };

  const currentImage = computed(() => {
    let iconToShow = leafIcon;
    if (isFolder.value) {
      iconToShow = isOpen.value ? folderOpenIcon : folderCloseIcon;
    }
    return iconToShow;
  });
</script>

<style scoped>
  .x-tree-node {
    text-decoration: none;
    padding: 1px 3px 1px 8px;
  }
  .tree-item-icon {
    float: left;
    padding-left: 1px;
  }

  .tree-item-content {
    padding-left: 21px;
    cursor: pointer;
  }
</style>
